<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color br-4">
          <div class="vx-row no-gutter br-4">
            <div class="vx-col sm:w-full md:w-full lg:w-full mx-auto self-center  d-theme-dark-bg br-4">
              <div class="vx-card__title card-header chat__bg card-header-dark " :class="themeClass">
                <h4 class="" style="">Create Account</h4>
              </div>
              <div class="px-8 register-tabs-container">
                <p class="mt-4 ">Fill the below form to create a new account.</p>
                <register-jwt></register-jwt>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import RegisterJwt from './PartitionJwt.vue'

export default {
  components: {
    RegisterJwt,
  },
  data() {
    return {
      theme: "light"
    };
  },
  computed: {
    themeClass() {
      return this.theme === "dark" ? "card-header-dark" : "card-header-lite";
    }
  },
  mounted() {
    const themeConfig = JSON.parse(localStorage.getItem("theme_config"));
    if (themeConfig && themeConfig.theme) {
      this.theme = themeConfig.theme;
    }
  }
}
</script>

<style lang="scss">
@import './index.scss';

.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
